import _inherits from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/esnext.global-this.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EventTarget = /*#__PURE__*/function () {
  function EventTarget() {
    _classCallCheck(this, EventTarget);
  }

  _createClass(EventTarget, [{
    key: "addEventListener",
    value: function addEventListener() {}
  }, {
    key: "removeEventListener",
    value: function removeEventListener() {}
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent() {
      return true;
    }
  }]);

  return EventTarget;
}();

var ResizeObserver = /*#__PURE__*/function () {
  function ResizeObserver() {
    _classCallCheck(this, ResizeObserver);
  }

  _createClass(ResizeObserver, [{
    key: "observe",
    value: function observe() {}
  }, {
    key: "unobserve",
    value: function unobserve() {}
  }, {
    key: "disconnect",
    value: function disconnect() {}
  }]);

  return ResizeObserver;
}();

var documentShim = {
  createElement: function createElement() {
    return new globalThisShim.HTMLElement();
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {}
};
var globalThisShim = {
  ResizeObserver: ResizeObserver,
  document: documentShim,
  HTMLElement: /*#__PURE__*/function (_EventTarget) {
    _inherits(HTMLElement, _EventTarget);

    var _super = _createSuper(HTMLElement);

    function HTMLElement() {
      _classCallCheck(this, HTMLElement);

      return _super.apply(this, arguments);
    }

    return _createClass(HTMLElement);
  }(EventTarget),
  DocumentFragment: /*#__PURE__*/function (_EventTarget2) {
    _inherits(DocumentFragment, _EventTarget2);

    var _super2 = _createSuper(DocumentFragment);

    function DocumentFragment() {
      _classCallCheck(this, DocumentFragment);

      return _super2.apply(this, arguments);
    }

    return _createClass(DocumentFragment);
  }(EventTarget),
  customElements: {
    get: function get() {},
    define: function define() {},
    whenDefined: function whenDefined() {}
  },
  CustomEvent: function CustomEvent() {},
  getComputedStyle: function getComputedStyle() {},
  navigator: {
    languages: []
  }
};
var isServer = typeof window === "undefined" || typeof window.customElements === "undefined";
var isShimmed = Object.keys(globalThisShim).every(function (key) {
  return key in globalThis;
});
var GlobalThis = isServer && !isShimmed ? globalThisShim : globalThis;
var Document = isServer && !isShimmed ? documentShim : globalThis.document;
export { Document, GlobalThis, Document as document, GlobalThis as globalThis, isServer };